import { InputConverterFunc } from '../../../inputConverter';

export interface IAssetSearchProps {
    columnName: string;
    data: string[];
    displayName: string;
    idType: string;
    propName: string;
    fieldName: string;
    layerId: number;
}

export default class AssetConfiguration implements IAssetSearchProps {
    constructor(obj?: IAssetSearchProps) {
        Object.assign(this, obj);
    }
    columnName = '';
    data = [];
    displayName = '';
    idType = '';
    propName = '';
    fieldName = '';
    layerId;
}

export let AssetConfigurationArrayConverter: InputConverterFunc<AssetConfiguration[]> = (value: any) => {
    if (typeof value === 'string') { return (<IAssetSearchProps[]> JSON.parse(value)).map(c => new AssetConfiguration(c)); }
    return value;
};
